import { Link } from 'react-router-dom';
import { docsCanonicalPath, PUSH_TROUBLESHOOTING_SLUG } from '@gitcenter/shared';
import './PushTroubleshootingCallout.css';

/**
 * 空仓库 / 创建仓库后：默认展开的推送排障提示（canonical /docs/...）
 */
export function PushTroubleshootingCallout() {
    const to = docsCanonicalPath(PUSH_TROUBLESHOOTING_SLUG);
    return (
        <aside className="push-troubleshoot-callout" aria-label="推送帮助">
            <div className="push-troubleshoot-callout-title">首次推送若失败</div>
            <p className="push-troubleshoot-callout-text">
                大仓库可能出现超时或体积限制，通常不是账号问题。终端在「Total … (delta …)」之后可能**长时间没有新输出**，多为服务端在处理，请勿立刻中断；详见文档。
            </p>
            <Link to={`${to}#silent-after-total`} className="push-troubleshoot-callout-link">
                打开推送排障文档（含「长时间无输出」说明）
            </Link>
        </aside>
    );
}
